import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {
    CrCustomerServiceNavigationComponent
} from "../../../../cr-customer/component/cr-customer-service-navigation/cr-customer-service-navigation.component";

// Deprecated
@Component({
    selector: 'cr-customer-service-navigation-consultant',
    templateUrl: './cr-customer-service-navigation-consultant.component.html',
    standalone: false
})
export class CrCustomerServiceNavigationConsultantComponent extends CrCustomerServiceNavigationComponent implements OnInit, OnChanges, OnDestroy {


ngOnInit() {
    super.ngOnInit();
}

}
